import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'datepicker';
import { bookingFormCommon } from "./c005-bookingform-common";

export class mHolidays {
    private bookingformcommon = new bookingFormCommon();

    mHolidayslist(): any {
        let _self = this;
        let defer = $.Deferred();
        _self.bookingformcommon.mHolidayslist().done((listData: any) => {
            defer.resolve(listData);
        });
        return defer.promise();
    }    
    transfermHolidayslist($scope:any){
        let _self = this;
        _self.bookingformcommon.populateTuiHotelList($scope);
    }
    mhcabinclass($scope:any){
        let _self = this;
        _self.bookingformcommon.cabinClass();
    }
    transferPickupmHolidayslist($scope:any){
        let _self = this;
        _self.bookingformcommon.transferPickupList($scope);
    }
    tourmHolidayslist($scope:any){
        let _self = this;
        _self.bookingformcommon.populatetourHotelList($scope);
    }
    populateTuiHotelList($scope:any){
        let _self = this;
        _self.bookingformcommon.populateTuiHotelList($scope);
    }
    hotelListNew(){       
        let _self = this;
        let defer = $.Deferred();
        _self.bookingformcommon.hotelListNew().done((listData: any) => {
            defer.resolve(listData);
        });
        return defer.promise();
    }
    parseOnDListItems(response: any, type: string): string {
        let _self = this;
        return _self.bookingformcommon.parseOnDListItems(response, type);
    }

    updateMholidaysOnDListOnFlowChange(originCode: any, updateType: any): void {
        let _self = this;
        _self.bookingformcommon.updateMholidaysOnDListOnFlowChange("mholiday", originCode.trim(), updateType);
    }

    //PDP
    pdpMholidayList():any{
        let _self = this;
        let defer = $.Deferred();
        _self.bookingformcommon.pdpMholidayList().done((listData: any) => {
            defer.resolve(listData);
        });
        return defer.promise();
    }
    updateMholidaysPdpOnDListOnFlowChange(originCode: any, updateType: any): void {
        let _self = this;
        _self.bookingformcommon.updateMholidaysPdpOnDListOnFlowChange("mholiday", originCode.trim(), updateType);
    }

    pdpHotelList():any{
        let _self = this;
        let defer = $.Deferred();
        _self.bookingformcommon.pdpHotelList().done((listData: any) => {
            defer.resolve(listData);
        });
        return defer.promise();
	}

}
